module.exports = __webpack_public_path__ + "img/image6.86fed197.png";